import React, { useEffect } from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LaunchIcon from '@mui/icons-material/Launch';
import { useLanguage } from '../context/LanguageContext';

const AdminRedirect = () => {
  const { adminSlug } = useLanguage();
  const activeSlug = (adminSlug || 'admin').trim();
  const currentPath = window.location.pathname.replace(/^\/|\/$/g, '').toLowerCase();

  const targetPath = activeSlug !== 'admin' ? `/${activeSlug}/` : '/admin/';
  const directPhpUrl = activeSlug !== 'admin' 
    ? `/admin/?slug=${encodeURIComponent(activeSlug)}` 
    : '/admin/';

  useEffect(() => {
    // If browser is already at custom slug or admin, direct straight to PHP endpoint with recovery parameter
    if (currentPath === activeSlug.toLowerCase()) {
      window.location.href = directPhpUrl;
    } else {
      window.location.href = targetPath;
    }
  }, [activeSlug, currentPath, targetPath, directPhpUrl]);

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={4}
          sx={{
            p: 5,
            textAlign: 'center',
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
            background: theme => theme.palette.mode === 'dark' ? 'rgba(17, 24, 39, 0.95)' : '#ffffff',
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              mx: 'auto',
              mb: 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #2E5BFF 0%, #00C896 100%)',
              color: 'white',
            }}
          >
            <LockOpenIcon fontSize="large" />
          </Box>

          <Typography variant="h5" fontWeight={700} gutterBottom>
            ITFORSEC Admin Portal
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Redirecting to the secure Flat-File Content Management Dashboard...
          </Typography>

          <Button
            variant="contained"
            size="large"
            href={targetPath}
            endIcon={<LaunchIcon />}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              fontWeight: 600,
              background: 'linear-gradient(135deg, #2E5BFF 0%, #00C896 100%)',
            }}
          >
            Open Admin Dashboard
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default AdminRedirect;
